import { useRefetchMerchantOnStageChange } from '@/components/loan-process/hooks/use-refetch-merchant-on-stage-change';

import { AgreementSmsTooManyAttempts } from './agreement-sms-too-many-attempts/agreement-sms-too-many-atempts';

export function StageEight() {
  useRefetchMerchantOnStageChange();

  return <AgreementSmsTooManyAttempts />;
}
